import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Pipe({
    name: 'timeLeftExist',
    pure: false
})
export class TimeLeftExistPipe implements OnDestroy, PipeTransform {
    _destroySbj: Subject<void> = new Subject();

    _subscription: Subscription = null;

    constructor(
        private _ref: ChangeDetectorRef
    ) {
    }

    ngOnDestroy() {
        this._dispose();
    }

    transform(endTime: number, startTime: number = new Date() .getTime()): any { //boolean {
        const now = new Date() .getTime();

        if (!(endTime > now && now >= startTime)) {
            this._dispose();

            return false;
        }

        if (!this._subscription) {
            this._subscribe()
        };

        return true;
    }

    _dispose() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }

    _subscribe() {
        this._subscription = timer(0, 1000)
            .pipe(takeUntil(this._destroySbj))
            .pipe(tap((time) => {
                this._ref.markForCheck()
            }))
            .subscribe()
    }

}
